<!-- Tree Overlay -->
<p-overlayPanel #tree_select
  class="flex flex-grow-1 overflow-hidden w-full">
  <medsurf-design-content-scroll-panel [height]="'20rem'"
    [width]="'50rem'">
    <medsurf-design-content-template-node-tree #template_node_tree
      [class]="'w-full'">
      <!-- No Data Template -->
      <ng-template #no_data_template>
        <div class="flex flex-grow-1 flex-shrink-1 flex-column row-gap-1 drag-node">
          <div class="flex flex-grow-1 flex-row column-gap-1 align-items-center p-1 pl-2 h-row border-round hover:surface-hover cursor-pointer">
            <div class="flex flex-grow-1 p-2 w-0">
              <span class="white-space-nowrap overflow-hidden text-overflow-ellipsis">
                {{ 'global.no_data' | translate }}
              </span>
            </div>
          </div>
        </div>
      </ng-template>

      <!-- Node Template -->
      <ng-template #override_node_template
        let-templateNodeTree="templateNodeTree"
        let-typedNodeExpanded="typedNodeExpanded"
        let-typedRouteElements="typedRouteElements"
        let-node="node"
        let-page="page">
        @if (typedRouteElements[node.id]; as routeElement) {
          <div class="flex flex-grow-1 flex-shrink-1 flex-column row-gap-1 drag-node"
            >
            <div class="flex flex-grow-1 flex-row column-gap-1 align-items-center p-1 pl-2 h-row border-round hover:surface-hover cursor-pointer h-3rem"
              [class.bg-white-alpha-10]="(nodeSharedFacade.currentSelectedRouteElement$ | async) === routeElement">
              <div class="flex w-3rem">
                <medsurf-design-input-checkbox [formField]="false"
                  [class]="'table-header-switch'"
                  [model]="isInArray(routeElement)"
                  [name]="'node_select_all_' + node.id"
                (valueChange)="onSwitchChange(routeElement, $event)"></medsurf-design-input-checkbox>
              </div>
              @if (routeElement.depth < 4) {
                <div
                  class="flex w-2rem">
                  <button medsurf-design-input-button [id]="'node_toggle_' + node.id"
                    [title]="(!typedNodeExpanded[node.id] ? 'global.node_toggle_open' : 'global.node_toggle_close') | translate"
                    [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_TEXT"
                    [iconClass]="(!typedNodeExpanded[node.id] || node.children.length === 0 ? FlatModels.ButtonDesignModels.ButtonDefaultIcons.RIGHT : FlatModels.ButtonDesignModels.ButtonDefaultIcons.DOWN)"
                    [disabled]="node.children.length === 0"
                  (click)="templateNodeTree.onNodeExpand(node)"></button>
                </div>
              }
              <div class="flex justify-content-center w-2rem">
                @if (page.type === FlatModels.PageEntityModels.PageType.enum.Slide && (slideAuthorFacade.media$(page.thumbnailMedia) | async); as media) {
                  <img class="max-w-2rem"
                    [src]="mediaControlService.getUrl(media, 'thumbnail') || '/assets/images/no-image.png'"
                    [alt]="media?.name || 'global.error_loading_image' | translate" />
                }
                @if (page.type !== FlatModels.PageEntityModels.PageType.enum.Slide) {
                  <i
                    [style.color]="getColor(page.themeColor)"
                  class="{{ FlatModels.PageEntityModels.PageTypeIcon[page.type] }} {{ getSolid(page.themeColor) }}"></i>
                }
              </div>
              <div class="flex flex-grow-1 w-0">
                <span class="white-space-wrap overflow-hidden text-overflow-ellipsis">
                  {{ page.title }}
                </span>
              </div>
            </div>
            @if (page.type !== FlatModels.PageEntityModels.PageType.enum.Slide && page.type !== FlatModels.PageEntityModels.PageType.enum.Training) {
              @if (nodeSharedFacade.nodeByIds$(node.children) | async | sortBy_shared:'asc':'position'; as childNodes) {
                <div [hidden]="!typedNodeExpanded[node.id]"
                  class="flex flex-1 flex-column row-gap-1 ml-4">
                  @if (node.children.length === 0) {
                    <ng-container *ngTemplateOutlet="no_data_template"></ng-container>
                  }
                  @if (childNodes.length === 0) {
                    @for (i of node.children; track i) {
                      <p-skeleton height="3rem" class="cursor-wait"></p-skeleton>
                    }
                  }
                  @if (childNodes.length > 0) {
                    <div>
                      <ng-container *ngFor="let childNode of childNodes; trackBy:templateNodeTree.trackByNode">
                      <!-- @for (childNode of childNodes; track templateNodeTree.trackByNode($index, childNode)) { -->
                        <ng-container *ngTemplateOutlet="override_node_template;context:{
                                      templateNodeTree,
                                      typedNodeExpanded,
                                      typedRouteElements,
                                      node: childNode,
                                      page: slideAuthorFacade.page$(childNode.page) | async}">
                        </ng-container>
                      </ng-container>
                    </div>
                  }
                </div>
              }
            }
          </div>
        }
      </ng-template>

      <!-- Menu Template -->
      <ng-template #override_menu_template
        let-templateNodeTree="templateNodeTree"
        let-typedNodeExpanded="typedNodeExpanded"
        let-typedRouteElements="typedRouteElements"
        let-elearnings="elearnings">
        <div class="flex flex-column row-gap-1">
          <ng-container *ngFor="let elearning of elearnings; trackBy:templateNodeTree.trackByNode">
          <!-- @for (elearning of elearnings; track templateNodeTree.trackByNode($index, elearning)) { -->
            <ng-container *ngTemplateOutlet="override_node_template,context:{
                          templateNodeTree,
                          typedNodeExpanded,
                          typedRouteElements,
                          node: elearning,
                          page: slideAuthorFacade.page$(elearning.page) | async}">
            </ng-container>
          </ng-container>
        </div>
      </ng-template>
    </medsurf-design-content-template-node-tree>
  </medsurf-design-content-scroll-panel>
</p-overlayPanel>
<!-- Node Tree Select Input -->
@if (name) {
  <div class="w-full"
       [class.field]="formField">
    @if (label) {
      <label
        id="{{ name }}_label"
        class="flex flex-grow-1"
        [class.mb-2]="!formField"
        for="{{ name }}">
        <span class="white-space-wrap overflow-hidden text-overflow-ellipsis">
          {{ label | translate }}
        </span>
      </label>
    }
    <p-multiSelect #treeMultiSelect
     inputId="{{ name }}"
     ariaLabelledBy="{{ name }}_label"
     styleClass="{{ inputClass }}"
     formControlName="{{ name }}"
     [maxSelectedLabels]="maxSelectedLabels"
     [selectedItemsLabel]="'{0} ' + ('global.selected_items_label' | translate)"
     [disableControl]="disabled"
     [options]="nodeTitleArray"
     optionLabel="name"
     optionValue="value"
     [readonly]="true"
     [placeholder]="placeholder | translate"
     (mouseup)="tree_select.toggle($event)"
     (onChange)="valueChange.emit($event)"
     [ngClass]="{
       'ng-invalid': control.invalid && control.touched,
       'ng-dirty': control.invalid && control.touched
     }">
    </p-multiSelect>
  </div>
}